import React, { useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom'
import { loadingToggleAction, loginAction } from '../../store/actions/AuthActions';
import logo from '../../assets/images/logo/logo-full.png'
import bg6 from '../../assets/images/background/bg6.jpg';

function Login(props) {
	const [heartActive, setHeartActive] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	const [username, setUsername] = useState('');
	let errorsObj = { username: '', password: '' };
	const [errors, setErrors] = useState(errorsObj);
	const [password, setPassword] = useState('');
	const dispatch = useDispatch();

	function onLogin(e) {
		e.preventDefault();
		let error = false;
		const errorObj = { ...errorsObj };
		
		if (username === '') {
			errorObj.username = 'Email or Mobile Number is Required';
			error = true;
		}
		if (password === '') {
			errorObj.password = 'Password is Required';
			error = true;
		}
		
		setErrors(errorObj);
		if (error) return;

		dispatch(loginAction({
			username: username.trim(),
			password: password
		}, navigate));
	}

	return (
		<div className="page-wraper">
			<div className="browse-job login-style3">
				<div className="bg-img-fix overflow-hidden" style={{background:'#fff url('+ bg6 + ')',  height: "100vh"}}>
					<div className="row gx-0">
						<div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 vh-100 bg-white ">
							<div id="mCSB_1" className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside" style={{maxHeight: "653px"}}>
								<div id="mCSB_1_container" className="mCSB_container" style={{position:"relative", top:"0", left:"0", dir:"ltr"}}>
									<div className="login-form style-2">
										<div className="card-body">
											<div className="logo-header">
												<Link to={"#"} className="logo"><img src={logo} alt="" className="width-230 mCS_img_loaded" /></Link>
											</div>
											<div className="nav nav-tabs border-bottom-0">
												<div className="tab-content w-100" id="nav-tabContent">
													<div className="tab-pane fade active show" id="nav-personal">
														{props.errorMessage && (
															<div className='bg-red-300 text-red-900 border border-red-900 p-1 my-2'>
																{props.errorMessage}
															</div>
														)}
														{props.successMessage && (
															<div className='bg-green-300 text-green-900 border border-green-900 p-1 my-2'>
																{props.successMessage}
															</div>
														)}
														<form className="dz-form pb-3" onSubmit={onLogin}>
															<h3 className="form-title m-t0">Personal Information</h3>
															<div className="dz-separator-outer m-b5">
																<div className="dz-separator bg-primary style-liner"></div>
															</div>
															<p>Enter your email/mobile number and password. </p>
															<div className="form-group mb-3">
																<input 
																	type="text" 
																	className="form-control" 
																	value={username}
																	onChange={(e) => setUsername(e.target.value)}
																	placeholder="Email or Mobile Number"
																/>
																{errors.username && <div className="text-danger fs-12">{errors.username}</div>}
															</div>
															<div className="form-group mb-3">
																<input 
																	type="password" 
																	className="form-control" 
																	value={password} 
																	onChange={(e) => setPassword(e.target.value)}
																	placeholder="Password"
																/>
																{errors.password && <div className="text-danger fs-12">{errors.password}</div>}
															</div>
															<div className="form-group text-left mb-5">
																<button type="submit" className="btn btn-primary dz-xs-flex m-r5">Login</button>
																<span className="form-check d-inline-block ms-2">
																	<input type="checkbox" className="form-check-input" id="check1" name="example1" />
																	<label className="form-check-label" htmlFor="check1">Remember me</label>
																</span>
															</div>
														</form>
														<div className="text-center bottom">
															<NavLink to="/page-register" className="btn btn-primary button-md btn-block">
																Create an account
															</NavLink>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const mapStateToProps = (state) => {
	return {
		isAuthenticated: state.auth.isAuthenticated && !!state.auth.token,
		errorMessage: state.auth.errorMessage,
		successMessage: state.auth.successMessage,
		showLoading: state.auth.showLoading,
	};
};

export default connect(mapStateToProps)(Login);